import { useHistory } from "react-router-dom"
import { useEffect, useState } from "react"
import 'bootstrap/dist/js/bootstrap.bundle.min';
import * as $ from "jquery"
// import { basePath } from "../../../routes/mainRoutes"
import { Modal } from "react-bootstrap"
import TabContent from "../page-editor/customize-page/tab-content"
import Loader, { hideLoader, showLoader } from "../loader"
import { useDispatch, useSelector } from "react-redux"
import ModalErrors from "../errors/modal-errors"
import { toast } from "react-toastify"
import { apiUrl } from "../../utils/url"
import customizeDomainsIcon from "../../assets/img/modals/customize-modal-domains-icon.svg"
import { audiencePosts as apiService } from "../../services/postRequests/audience";
import CustomDomainDotModal from "../../components/page-editor/block-editor/sub-modals/customDomainDotModal";
import Teammoadal from "../teammember/team_modal";
import CustomDomainConnectedModal from "../page-editor/block-editor/sub-modals/customDomainConnectedModal";


const Domains = ({setActivePage}) => {
    const history = useHistory()
    const dispatch = useDispatch()
    const [error, setError] = useState([])
    const { basePath, slug } = useSelector(state => state?.slugReducer);
    const value = useSelector(state => state?.customizeDomainsReducer);
    const [isdomainConnect, setisdomainConnect] = useState(value?.domain ? true : false);
    const showCustomDomainDotsModal = useSelector(state => state?.domainDotModalShowReducer);
    const [showModalasd, setShowModalasd] = useState(false)
    const isEligiblie = useSelector(state => state?.eligibilityReducer);


    const handleChange = (e) => dispatch({ type: "SET_CUSTOMIZE_DOMAINS", payload: { ...value, [e.target.name]: e.target.value } })
    const handleSubmit = (e, values) => {
        e.preventDefault()
        setTimeout(() => {
            dispatch({
                type: "SET_DOMAIN_MODAL_SHOW", payload: {
                    dotModal: true,
                    connectedModal: false,
                }
            });
            // hideLoader()
        }, 200);
        setError([]);
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const formdata = new FormData();
        const formValues = { ...values, project: slug };

        for (const key in formValues) {
            if (Object.hasOwnProperty.call(formValues, key)) {
                formdata.append(key, formValues[key]);
            }
        }

        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        fetch(apiUrl + "/project/update", requestOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    setisdomainConnect(true)
                    toast.success(response?.status_message);
                    handleDotModals()
                }

                else {
                    let errorList = []
                    response?.errors?.domain?.map((val) => errorList?.push(val));
                    setError(errorList);
                    dispatch({
                        type: "SET_DOMAIN_MODAL_SHOW", payload: {
                            dotModal: false,
                            connectedModal: false,
                        }
                    });
                    toast.error(response?.status_message)
                }
            })
            .catch((err) => {
                dispatch({
                    type: "SET_DOMAIN_MODAL_SHOW", payload: {
                        dotModal: false,
                        connectedModal: false,
                    }
                });
                // handleClose()
            })
    }
    const disconnectDomain = (id) => {
        showLoader();
        const api = apiUrl + "/project/deletedomain/" + id;
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`);
        const setOptions = {
            method: "DELETE",
            headers: myHeaders,
        }
        apiService(api, hideLoader, setOptions).then(() => {
            setisdomainConnect(false)
            hideLoader();
            dispatch({ type: 'RESET_CUSTOMIZE_DOMAINS' })
        }).catch((err) => {
        })
    }
    const handleClose = () => {
        setTimeout(() => {
            history.push(`${basePath}/page-editor/customizePageModal/customizePageDomains`)
        }, 300);
    }

    const handleDotModals = () => {
        dispatch({
            type: "SET_DOMAIN_MODAL_SHOW", payload: {
                dotModal: false,
                connectedModal: true,
            }
        });
    }
    const handleHideConnectedModal = (onDomain) => {
        dispatch({ type: "SET_DOMAIN_MODAL_SHOW", payload: { dotModal: false, connectedModal: false } });
    }
    return (

        <section className="container h-100 position-relative">
           <div className="container settings-section" style={{padding:"30px 30px 30px 20px"}}>  
            <div class="">
                <h1 class="settings-section-heading mb-0" >Domains</h1>
            </div>
            {!isdomainConnect &&<>
            <form name="create_folder" class="account-form" method="post" role="form" onSubmit={(e) => handleSubmit(e, value)}>
                    

                {/* <div class="form-group">
                    <label><small>Step 1: Add an A record to your DNS</small></label>
                    <input type="text" class={`form-control zaap-form-control`} name="name" required="required" placeholder="" value="52.201.4.2" readonly />
                </div> */}
                <div class="notification-container"></div>
                <div className="domain-steps-label" style={{marginTop:"20px",marginBottom:"11px"}}>
                    Step 1: Add an A record to your DNS
                </div>
                <div class="form-group  w-100 domain-first-step-fields" >
                    <div className="first-step-name-field">
                        <label><small>Name</small></label>
                        <input type="text" class={`form-control text-center`} name="name" value="@" readonly/>
                    </div>
                    <div className="first-step-value-field">
                        <label><small>Value</small></label>
                        <div class="form-control p-0 position-relative">
                            <input type="text" class={`form-control w-100`} name="value" value="34.226.84.124 " readonly/>
                                <span className="first-step-value-icon" onClick={() => {navigator.clipboard.writeText(`${"34.226.84.124"}`).then((r) => toast.success("Successfully Copied"))}}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.32121 0.255372C2.32895 0.255372 2.33672 0.255372 2.34451 0.255372L6.01933 0.255372C6.25328 0.255363 6.45936 0.255355 6.63077 0.267051C6.81249 0.279449 7.00038 0.307053 7.18791 0.384733C7.60432 0.557214 7.93515 0.888047 8.10763 1.30445C8.18531 1.49199 8.21292 1.67988 8.22532 1.8616C8.23701 2.03301 8.237 2.23909 8.23699 2.47303V2.49237C8.23699 2.83715 7.9575 3.11664 7.61272 3.11664C7.26794 3.11664 6.98844 2.83715 6.98844 2.49237C6.98844 2.23335 6.9881 2.07035 6.97966 1.94659C6.9716 1.82844 6.95828 1.7923 6.95412 1.78225C6.90836 1.67178 6.82059 1.58401 6.71011 1.53825C6.70007 1.53409 6.66393 1.52077 6.54578 1.51271C6.42202 1.50427 6.25902 1.50393 6 1.50393H2.34451C2.03314 1.50393 1.83716 1.50441 1.68919 1.5165C1.54852 1.528 1.50705 1.54679 1.49473 1.55307C1.4099 1.59629 1.34092 1.66527 1.2977 1.7501C1.29142 1.76242 1.27262 1.80389 1.26113 1.94456C1.24904 2.09253 1.24856 2.28851 1.24856 2.59988V6.25537C1.24856 6.51439 1.24889 6.67739 1.25734 6.80115C1.2654 6.9193 1.27872 6.95544 1.28288 6.96548C1.32864 7.07596 1.41641 7.16373 1.52688 7.20949C1.53693 7.21365 1.57307 7.22697 1.69122 7.23503C1.81498 7.24347 1.97798 7.24381 2.237 7.24381C2.58177 7.24381 2.86127 7.52331 2.86127 7.86809C2.86127 8.21287 2.58177 8.49237 2.237 8.49237H2.21766C1.98371 8.49237 1.77764 8.49238 1.60623 8.48069C1.42451 8.46829 1.23662 8.44069 1.04908 8.363C0.632676 8.19052 0.301843 7.85969 0.129362 7.44328C0.0516823 7.25575 0.0240782 7.06786 0.0116794 6.88614C-1.56436e-05 6.71473 -7.90398e-06 6.50865 8.27931e-07 6.27471L1.35714e-06 2.59988C1.35714e-06 2.59209 1.02638e-06 2.58432 6.9563e-07 2.57658C-1.20053e-05 2.29545 -2.30525e-05 2.04785 0.0167226 1.84289C0.0345248 1.625 0.0743206 1.40094 0.185227 1.18327C0.348157 0.863506 0.608135 0.603528 0.927902 0.440598C1.14557 0.329692 1.36963 0.289896 1.58752 0.272094C1.79248 0.255348 2.04008 0.255359 2.32121 0.255372ZM6.08422 4.01838H9.67879C9.95993 4.01836 10.2075 4.01835 10.4125 4.0351C10.6304 4.0529 10.8544 4.0927 11.0721 4.2036C11.3919 4.36653 11.6518 4.62651 11.8148 4.94628C11.9257 5.16394 11.9655 5.38801 11.9833 5.6059C12 5.81085 12 6.05844 12 6.33957V9.93417C12 10.2153 12 10.4629 11.9833 10.6679C11.9655 10.8857 11.9257 11.1098 11.8148 11.3275C11.6518 11.6472 11.3919 11.9072 11.0721 12.0701C10.8544 12.1811 10.6304 12.2208 10.4125 12.2386C10.2075 12.2554 9.95993 12.2554 9.6788 12.2554H6.0842C5.80307 12.2554 5.55548 12.2554 5.35053 12.2386C5.13264 12.2208 4.90857 12.1811 4.69091 12.0701C4.37114 11.9072 4.11116 11.6472 3.94823 11.3275C3.83733 11.1098 3.79753 10.8857 3.77973 10.6679C3.76298 10.4629 3.76299 10.2153 3.76301 9.93416V6.33959C3.76299 6.05845 3.76298 5.81085 3.77973 5.6059C3.79753 5.38801 3.83733 5.16394 3.94823 4.94628C4.11116 4.62651 4.37114 4.36653 4.69091 4.2036C4.90857 4.0927 5.13264 4.0529 5.35053 4.0351C5.55548 4.01835 5.80308 4.01836 6.08422 4.01838ZM5.4522 5.27951C5.31152 5.291 5.27006 5.3098 5.25774 5.31607C5.1729 5.3593 5.10393 5.42827 5.0607 5.51311C5.05443 5.52543 5.03563 5.56689 5.02414 5.70757C5.01205 5.85553 5.01156 6.05152 5.01156 6.36289V9.91086C5.01156 10.2222 5.01205 10.4182 5.02414 10.5662C5.03563 10.7069 5.05443 10.7483 5.0607 10.7606C5.10393 10.8455 5.1729 10.9144 5.25774 10.9577C5.27006 10.964 5.31152 10.9827 5.4522 10.9942C5.60016 11.0063 5.79614 11.0068 6.10751 11.0068H9.65549C9.96686 11.0068 10.1628 11.0063 10.3108 10.9942C10.4515 10.9827 10.4929 10.964 10.5053 10.9577C10.5901 10.9144 10.6591 10.8455 10.7023 10.7606C10.7086 10.7483 10.7274 10.7069 10.7389 10.5662C10.751 10.4182 10.7514 10.2222 10.7514 9.91086V6.36289C10.7514 6.05152 10.751 5.85553 10.7389 5.70757C10.7274 5.56689 10.7086 5.52543 10.7023 5.51311C10.6591 5.42827 10.5901 5.3593 10.5053 5.31607C10.4929 5.3098 10.4515 5.291 10.3108 5.27951C10.1628 5.26742 9.96686 5.26693 9.65549 5.26693H6.10751C5.79614 5.26693 5.60016 5.26742 5.4522 5.27951Z" fill="#6F6E7A"/>
                                </svg>
                                </span>
                        </div>
                    </div>
                    <div className="first-step-ttl-field">
                        <label><small>TTL</small></label>
                        <input type="text" class={`form-control text-center`} name="ttl" value="Auto" readonly/>
                    </div>
                </div>
                <div className="domain-steps-label" style={{marginTop:"17px"}}>
                    Step 2: Enter your domain
                </div>
                <div class="d-flex justify-content-between align-items-end">
                    <div class="form-group mt-3 w-100" style={{marginRight:"8px"}}>
                        <input type="url" class={`form-control`} name="domain" onChange={handleChange} required="required" placeholder="https://mydomain.com" />
                        
                    </div>

                    <button type="submit" style={{maxWidth: "72px"}} class="btn settings-connect-btn btn-primary btn-semi-rounded">
                        Connect
                    </button>
                </div>
                <ModalErrors text={error} />
            </form>
            </>}
            {isdomainConnect && <>{value?.domain ?
                        <div class="container custom-domain-input-group domain-enabled d-flex justify-content-between align-items-center border-0">
                            <div className="d-flex justify-content-start align-items-center">
                            <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
                                <rect width="30" height="30" rx="9" fill="#FF1451"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M15.4959 9.07832C16.2197 8.37858 17.1892 7.99139 18.1955 8.00015C19.2018 8.0089 20.1643 8.41289 20.8759 9.12512C21.5875 9.83734 21.9911 10.8008 21.9999 11.808C22.0086 12.8152 21.6218 13.7855 20.9227 14.51L20.9149 14.518L18.996 16.4386C18.996 16.4386 18.996 16.4386 18.996 16.4386C18.607 16.8281 18.1387 17.1294 17.6231 17.3219C17.1075 17.5145 16.5565 17.5937 16.0076 17.5544C15.4587 17.515 14.9246 17.358 14.4416 17.0939C13.9587 16.8298 13.5381 16.4648 13.2085 16.0237C12.9969 15.7406 13.0547 15.3393 13.3376 15.1276C13.6205 14.9158 14.0213 14.9736 14.2329 15.2567C14.4527 15.5508 14.733 15.7941 15.055 15.9702C15.377 16.1463 15.733 16.251 16.099 16.2772C16.4649 16.3034 16.8322 16.2506 17.176 16.1222C17.5197 15.9939 17.8319 15.793 18.0913 15.5333L20.0062 13.6167C20.4699 13.1341 20.7264 12.4888 20.7206 11.8191C20.7148 11.1477 20.4457 10.5054 19.9713 10.0305C19.4969 9.55572 18.8552 9.28639 18.1844 9.28056C17.515 9.27474 16.87 9.53173 16.3878 9.99631L15.2911 11.0877C15.0405 11.337 14.6355 11.3358 14.3865 11.085C14.1374 10.8343 14.1386 10.4289 14.3891 10.1796L15.4893 9.0848L15.4959 9.07832ZM12.3769 12.6781C12.8925 12.4855 13.4435 12.4063 13.9924 12.4456C14.5413 12.485 15.0754 12.642 15.5583 12.9061C16.0413 13.1702 16.4619 13.5352 16.7915 13.9763C17.0031 14.2594 16.9453 14.6607 16.6624 14.8724C16.3795 15.0842 15.9787 15.0264 15.7671 14.7433C15.5473 14.4492 15.267 14.2059 14.945 14.0298C14.623 13.8537 14.267 13.749 13.901 13.7228C13.5351 13.6966 13.1678 13.7494 12.824 13.8778C12.4803 14.0061 12.1681 14.207 11.9087 14.4667L9.99387 16.3833C9.53011 16.8659 9.27357 17.5112 9.27939 18.1809C9.28522 18.8523 9.5543 19.4946 10.0287 19.9695C10.5031 20.4443 11.1448 20.7136 11.8156 20.7194C12.4847 20.7253 13.1294 20.4685 13.6116 20.0043L14.7012 18.9137C14.951 18.6636 15.356 18.6636 15.6058 18.9137C15.8556 19.1637 15.8556 19.5691 15.6058 19.8191L14.512 20.9139L14.5041 20.9217C13.7803 21.6214 12.8108 22.0086 11.8045 21.9999C10.7982 21.9911 9.83566 21.5871 9.12409 20.8749C8.41251 20.1627 8.00889 19.1992 8.00015 18.192C7.9914 17.1848 8.37824 16.2145 9.07734 15.49L9.08513 15.482L11.004 13.5614C11.004 13.5614 11.004 13.5614 11.004 13.5614C11.393 13.1719 11.8613 12.8706 12.3769 12.6781Z" fill="white"/>
                            </svg>
                                <p class="mb-0 p-2 ms-1">{value?.domain}</p>
                            </div>
                            <button type="button" onClick={() => disconnectDomain(value?.project_id)}
                                class="customDomainModal disconnect-domin-btn">
                                Disconnect
                            </button>
                        </div>
                    
                    : ""
                } </>}
            </div>
            {showCustomDomainDotsModal?.dotModal && <CustomDomainDotModal show={showCustomDomainDotsModal?.dotModal} />}
            {showCustomDomainDotsModal?.connectedModal && <CustomDomainConnectedModal show={showCustomDomainDotsModal?.connectedModal} handleHide={handleHideConnectedModal} />}
            {showModalasd && <Teammoadal from={"domain-settings"} showModal={showModalasd} setShowModal={setShowModalasd} setActivePage={setActivePage} text={'Custom Domain is a Ultra feature. <br /> Upgrade to Zaap Ultra to unlock this feature.'} isUltra={true}/>}
        </section>

    )

}
export default Domains